import axios, { AxiosResponse } from "axios";
import { WhereFilter } from "../utils/WhereFilter";
import React from "react";

export interface IndexResponse<T> {
  models: Array<T>;
  response: AxiosResponse;
  totalModels: number;
}

export interface GetResponse<T> {
  model: T;
  response: AxiosResponse;
}

export interface DatabaseModelElement {
  tableRow(): JSX.Element;
}

export class DatabaseModel {
  id: number | undefined;

  static modelName = "subsDatabaseModel";

  static index(filters: WhereFilter[] = [], page = 1, perPage = 250): Promise<any> {
    if (this.name === "DatabaseModel") {
      throw new Error("Cannot use method from DatabaseModel Class");
    }
    return new Promise((resolve: (value: IndexResponse<any>) => void, reject) => {
      axios
        .post("core/" + this.modelName + `/search?page=${page}&per_page=${perPage}`, filters)
        .then((response: AxiosResponse) => {
          resolve({
            models: response.data.data.data.map((model: object) => this.CreateModel(model)),
            totalModels: response.data.data.total,
            response,
          });
        });
    });
  }

  static get(id: number): Promise<any> {
    if (this.name === "DatabaseModel") {
      throw new Error("Cannot use method from DatabaseModel Class");
    }
    return new Promise((resolve: (value: GetResponse<any>) => void, reject) => {
      axios.get("core/" + this.modelName + "/" + id).then((response: AxiosResponse) => {
        resolve({ model: this.CreateModel(response.data.data), response });
      });
    });
  }

  public apiCreate(): Promise<any> {
    const data = JSON.parse(JSON.stringify(this));
    return new Promise((resolve: (value: GetResponse<any>) => void, reject) => {
      axios
        .post("core/" + (this.constructor as typeof DatabaseModel).modelName, data)
        .then((response) => {
          resolve({ model: (this.constructor as typeof DatabaseModel).CreateModel(response.data.data), response });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public apiUpdate(newValues: { [x: string]: any }): Promise<any> {
    // only send newValues or all values if there are no newValues set
    let data: any = {};
    if (Object.keys(newValues).length === 0) {
      data = JSON.parse(JSON.stringify(this));
    } else {
      Object.keys(newValues).forEach((key) => {
        data[key] = newValues[key];
      });
      data.id = this.id;
    }
    return new Promise((resolve: (value: GetResponse<any>) => void, reject) => {
      axios
        .patch("core/" + (this.constructor as typeof DatabaseModel).modelName + "/" + this.id, data)
        .then((response) => {
          resolve({
            model: (this.constructor as typeof DatabaseModel).CreateModel(response.data.data),
            response,
          });
        });
    });
  }

  public apiDelete(): Promise<any> {
    // only send newValues or all values if there are no newValues set
    let data: any = {};

    data = JSON.parse(JSON.stringify(this));

    return new Promise((resolve: (value: GetResponse<any>) => void, reject) => {
      axios
        .delete("core/" + (this.constructor as typeof DatabaseModel).modelName + "/" + this.id, data)
        .then((response) => {
          resolve({
            model: (this.constructor as typeof DatabaseModel).CreateModel(response.data.data),
            response,
          });
        });
    });
  }

  static CreateModel(model: any): DatabaseModel {
    return new DatabaseModel();
  }

  static editPath(id: number): string {
    return `/manager/${this.modelName}s/${id}/edit`;
  }

  tableRow() {
    return (
      <>
        {/*<Grid item xs={3}>*/}
        {/*  {this.company_name}*/}
        {/*</Grid>*/}
        {/*<Grid item xs={3}>*/}
        {/*  {this.company_city}*/}
        {/*</Grid>*/}
        {/*<Grid item xs={3}>*/}
        {/*  {formatDate(this.gripp_created_at)}*/}
        {/*</Grid>*/}
        {/*<Grid item xs={2}>*/}
        {/*  <Link to={{ pathname: this.editPath(this.id) }}>*/}
        {/*    <Visibility />*/}
        {/*  </Link>*/}
        {/*</Grid>*/}
      </>
    );
  }
}
